import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-6 py-24 flex flex-col items-center justify-center text-center min-h-[60vh]">
      <span className="w-16 h-16 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center mb-5">
        <i className="ri-basketball-line text-3xl" />
      </span>
      <p className="font-heading font-semibold text-5xl md:text-6xl text-foreground-950">404</p>
      <h1 className="mt-4 font-heading text-xl md:text-2xl text-foreground-900">
        页面走丢了，就像投丢的一个球
      </h1>
      <p className="mt-3 max-w-md text-sm md:text-base text-foreground-600 leading-relaxed">
        你访问的页面可能已被移动或不存在，不妨回到首页，看看今晚有哪些比赛正在直播。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/schedule"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-foreground-800 hover:bg-background-100 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-calendar-line" />
          查看赛程
        </Link>
      </div>
    </div>
  );
}